import React, { useState } from "react";
import Zippy from "./Zippy";
import { getMarkDown } from "../utils";
import "../../../stylesheets/triagebot/OvPossibleCauses.scss";
import { ReactComponent as ThumbUpIcon } from "../../../assets/thumb_up.svg";
import { ReactComponent as ErrorExclamationIcon } from "../../../assets/error_exclamation.svg";
import { ReactComponent as  WarningRoundedIcon } from "../../../assets/warning_rounded.svg";
import PossibleCausesLink from "../dialogs/PossibleCausesLink";

const OvPossibleCauses = ({ message, setToastMessage }) => {
  const [isExpanded, setIsExpanded] = useState(false); // Collapsed by default
  
  const [openZippy, setOpenZippy] = useState(-1);
  const [showElement, setShowElement] = useState(null);

  const headerText = message?.data?.[2]?.summaryCardContent?.openPossibleCausesHeader
  ? message.data[2].summaryCardContent.openPossibleCausesHeader
  : 'Possible Conditions';

  const subheaderClosed =  message?.data?.[2]?.summaryCardContent?.openPossibleCausesSubHeaderTextExpand
  ? message.data[2].summaryCardContent.openPossibleCausesSubHeaderTextExpand
  :"Click the arrow to expand this section";

  const subheaderOpen =  message?.data?.[2]?.summaryCardContent?.openPossibleCausesSubHeaderTextCollapse
  ? message.data[2].summaryCardContent.openPossibleCausesSubHeaderTextCollapse
  :"Click the arrow to collapse this section";

  const subheaderText = isExpanded ? subheaderOpen : subheaderClosed;

  const updateZippy = (e, cause, zippy) => {
  zippy === openZippy ? setOpenZippy(-1) : setOpenZippy(zippy);

  const el = document.getElementById("summary-header");
  if (el) setShowElement(el);
  };

  const getBadgeConfig = (severity) => {
    switch (severity) {
      case "mild":
        return {
          label: "Mild",
          Icon: ThumbUpIcon,
          className: "severity-badge severity-badge--mild",
        };
      case "moderate":
        return {
          label: "Moderate",
          Icon: WarningRoundedIcon,
          className: "severity-badge severity-badge--moderate",
        };
      case "severe":
        return{
          label: "Severe",
          Icon: ErrorExclamationIcon,
          className: "severity-badge severity-badge--severe",
        }
      default:
        return null;
    }
}
  

 const instructions = message?.data?.[2]?.possibleCausesContent?.instruction
    ? message?.data?.[2]?.possibleCausesContent?.instruction
    : "";

  const noCauses = message?.data?.[2]?.possibleCausesContent?.noPossibleCauses
    ? message.data[2].possibleCausesContent.noPossibleCauses
    : "";

  const sections = message?.data?.[2]?.possibleCausesContent?.sectionHeaders.length
    ? message.data[2].possibleCausesContent.sectionHeaders
    : ["", "", "",];

  const whyResult = message?.data?.[2]?.possibleCausesContent?.resultReason
    ? message.data[2].possibleCausesContent.resultReason
    : "";

  const causes = message?.data?.[1]?.possible_causes
    ? message.data[1].possible_causes
    : [];

  const severity = message?.data?.[1]?.possible_causes[0]?.severity
    ? message.data[1].possible_causes[0].severity
    : ""

  const sourcesTxt = message?.data?.[2]?.possibleCausesContent?.sectionHeaders?.[3]
    ? message.data[2].possibleCausesContent.sectionHeaders[3]
    : '';

  causes.forEach((cause) => {
    cause.sources =
      cause && Array.isArray(cause.sources) ? cause.sources : [];
  });

  const titleCase = (str) => {

    return str
      .toLowerCase()
      .split(" ")
      .map(function (word) {
        return word.replace(word[0], word[0].toUpperCase());
      })
      .join(" ");
  };
  
  const defeatListingItems = (text) => {

    const dotLocation = text.indexOf(".");
    if (dotLocation < 0) return text;

    const number = text.slice(0, dotLocation) * 1;
    const dot = text.slice(dotLocation, dotLocation + 2);

    if (isNaN(number)) return text;
    if (dot !== ". ") return text;

    return text.slice(0, dotLocation) + "\\" + text.slice(dotLocation);
  };

  return (
    <div className="possible-causes">
      <Zippy
        title={headerText}
        belowHeader={
          <div className="possible-causes-subheader">
            {getMarkDown(subheaderText)}
          </div>
        }
        open={isExpanded}
        onClick={() => setIsExpanded(!isExpanded)}
        type="bar"
      >
        <div className="expanded-content">

          {causes.length ? (
          causes.map((cause, index) => {
            const Badge = getBadgeConfig(cause.severity);
            return (
              <Zippy
                className="cause-title"
                key={"cause" + index}
                title={
                  <div className="cause-title-wrapper">
                    <span className="cause-title-text">
                      {titleCase(
                        cause.common_medline_name
                          ? cause.common_medline_name
                          : cause.common_name
                      )}
                    </span>
                    {Badge && (
                      <span className={Badge.className}>
                        <Badge.Icon className="severity-icon" />
                        <span>{Badge.label}</span>
                      </span>
                    )}
                  </div>
                }
                open={openZippy === index}
                onClick={(e) => {
                  updateZippy(e, cause, index);
                }}
              >
                <div className="brief">
                  {getMarkDown(cause.brief_summary)}
                </div>

                {
                  cause.complete_summary
                    ?
                    <div>
                      <span className="headerText">{sections[0]}</span>
                      <div className="section">
                      {getMarkDown(cause.complete_summary)}
                      </div>
                    </div>
                    : null
                }

                {
                  cause.self_care_advice
                    ?
                    <div>
                      <span className="headerText">{sections[1]}</span>
                      <div className="section">
                        {getMarkDown(cause.self_care_advice)}
                      </div>
                    </div>
                    : null
                }

                {
                  cause.see_provider
                    ?
                    <div>
                        <span className="headerText">{sections[2]}</span>
                      <div className="section">
                      {getMarkDown(cause.see_provider)}
                      </div>
                    </div>
                    : null
                }

                {
                  cause.sources.length
                    ?
                    <Zippy
                      key={"sources" + index}
                      type="text"
                      title={sourcesTxt}
                      className="sources"
                    >
                      {cause.sources.map((source, i) => {
                        return (
                          <div
                            key={"cause" + index + "source" + i}
                            className="sources"
                          >
                            {getMarkDown(defeatListingItems(source))}
                          </div>
                        );
                      })}
                    </Zippy>
                    : ""
                }

                {
                  cause.hasOwnProperty("explanationResponse")
                    ?
                    <div className="explanation">
                      <button
                        className="whyDidIButton"
                        style={{ color: `var(--primary-color)`, cursor: "pointer", fontFamily: 'var(--font-family)' }}
                        onClick={() =>
                          setToastMessage({
                            type: "causes",
                            header: cause.explanationResponse.header,
                            body: (
                              <PossibleCausesLink
                                message={cause.explanationResponse}
                              />
                            ),
                          })
                        }
                      >
                        {whyResult}
                      </button>
                    </div>
                    : null
                }
              </Zippy>
            )})
          ):
          (
        <div className="no-causes">{getMarkDown(noCauses)}</div>
      )}
        </div>
      </Zippy>
    </div>
  );
};

export default OvPossibleCauses;